import MenuButton from '../../../controls/MenuButton'

export class DropdownSelectorButton extends MenuButton {
    constructor({
        editable = true,
        menu = null,
        positionParams = {offset: "0px 1px"},
        onChangeValue = (value) => {},
        onShowMenu = () => {},
        onHideMenu = () => {},
    }) {
        super({
            editable,
            positionParams,
            onShowMenu,
            onHideMenu
        })

        this.onChangeValue = onChangeValue
        this.menu = menu

        this.state = {
            value: '',
            options: [],
        }

        this.onStatePropertyChanged('value', () => {
            this.update()
        })
    }

    templateHtml() {
        return "<div class='dropdownSelectorButton'>" +
               " <div class='value ellipsis'/>" +
               "</div>"
    }

    afterRender() {
        super.afterRender()
        this.$value = this.find('.value')
        this.update()
    }

    update() {
        super.update()
        this.$value.text(this.state.value)
        this.getEl().attr('title', this.state.value)
    }

    getMenu() {
        this.menu.setState({
            options: this.state.options,
            selectedOption: this.state.value,
        })
        return this.menu
    }

    _change(value) {
        if (value !== this.state.value) {
            this.setState({value})
            this.onChangeValue(value)
            return true
        }
        return false
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/customFields/DropdownSelectorButton.js